import * as THREE from "three";

export function createWebGLRenderer() {
  const renderer = new THREE.WebGLRenderer({
    antialias: true,
    alpha: true,
    preserveDrawingBuffer: true, // Required for toDataURL to work
  });
  renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2));

  // Linear tone mapping at 1.0 exposure — matches the neutral studio environment.
  renderer.toneMapping = THREE.LinearToneMapping;
  renderer.toneMappingExposure = 1;

  renderer.domElement.style.width = "100%";
  renderer.domElement.style.height = "100%";
  renderer.domElement.style.display = "block";
  renderer.domElement.style.touchAction = "none";
  // Border radius will be set dynamically based on screen size

  return renderer;
}
